import React, { useState } from 'react'

import {
    createColumnHelper,
    flexRender,
    getCoreRowModel,
    useReactTable,
} from '@tanstack/react-table'

type Person = {
    csvHeader: string
    value: string
    selected: string
}

const columnHelper = createColumnHelper<Person>()

const TableCsvMapping = ({ 
    tableData, 
    setTableData, 
    canManage,
    team
}) => {

    const [data, setData] = useState([...tableData])

    const columns = [
        columnHelper.accessor('csvHeader', {
            cell: info => info.getValue(),
            footer: info => info.column.id,
            header: () => <span>CSV Header</span>,
        }),
        columnHelper.accessor('value', {
            cell: info => info.getValue(),
            header: () => <span>Value</span>,
        }),
        columnHelper.accessor('selected', {
            cell: info => (
                <SelectTarget props={info}/>
            ),
            header: () => <span>Target</span>,
        }),
    ]

    const SelectTarget = ({props}) => {
        const originalSelected =  props.row.original['selected']

        const handleSelectChange = ( e:React.ChangeEvent<HTMLSelectElement> | string) => {
            const rowId = Number(props.row.id)
            
            const newData = data.map((thisData: object, key: number) => {
                if( key === rowId ){
                    thisData['selected'] = e.target.value
                }
                return thisData
            })

            setTableData( newData )
        }

        const options = () => {
            return team.csv_headers.map((header) => {
                return (
                    <option value={header}>{header}</option>
                )
            })
        }
        
        return (
          <select defaultValue={originalSelected} onChange={handleSelectChange} >
            <option selected value> -- select an option -- </option>
            { options() }
            {
                ( canManage && !team.csv_headers.includes('team_id') ) && (
                    <option value="team_id">Team ID</option>
                )
            }
          </select>
        )
    }


    const table = useReactTable({
        data,
        columns,
        getCoreRowModel: getCoreRowModel(),
    })

    return (
      <>
        <div className='msync-modal-upload-container'>
          <strong>Match columns</strong>
          <p>
            Map the data to the proper CSV column headings. For existing users only the Role meta will be updated.
          </p>
        </div>
        <div className="msync-tanstack">
          <table className='msync-table'>
              <thead className='msync-table-header'>
                  {table.getHeaderGroups().map(headerGroup => (
                  <tr key={headerGroup.id}>
                      {headerGroup.headers.map(header => (
                      <th key={header.id}>
                          {header.isPlaceholder
                          ? null
                          : flexRender(
                              header.column.columnDef.header,
                              header.getContext()
                              )}
                      </th>
                      ))}
                  </tr>
                  ))}
              </thead>
              <tbody>
                  { table.getRowModel().rows.map(row => (
                      <tr key={row.id}>
                          {row.getVisibleCells().map(cell => (
                          <td key={cell.id}>
                              {flexRender(cell.column.columnDef.cell, cell.getContext())}
                          </td>
                          ))}
                      </tr>
                  ))}
              </tbody>
          </table>
        </div>
      </>
    )
}

export default TableCsvMapping
